import { el } from 'redom';

import TextInput from 'generics/components/text-input';
import TextAreaBox from 'generics/components/text-input/text-area-box';
import TextInputBox from 'generics/components/text-input/text-input-box';
import FieldLabel from 'generics/components/field-label';

class TextInputRow {

  constructor(configuration) {

    this.onChange = configuration.onChange;
    this.input = new TextInput({
      ...configuration,
      onChange: this.onChange
    });
    const className = configuration.class || '';
    this.el = el('.form-input-row' + className, [
      new FieldLabel({ text: configuration.label, tip: configuration.tip, class: configuration.labelClass }),
      this.input
    ]);

  }

}

export class TextInputBoxRow {

  constructor(configuration) {

    this.inputBox = new TextInputBox(configuration);
    const className = configuration.class || '';
    this.el = el('.form-input-row' + className, [
      new FieldLabel({ text: configuration.label, tip: configuration.tip, fullText: configuration.fullText }),
      this.inputBox
    ]);

  }

}

export class TextareaInputBoxRow {

  constructor(configuration) {

    this.inputBox = new TextAreaBox(configuration);
    const className = configuration.class || '';
    this.el = el('.form-input-row' + className, [
      new FieldLabel({ text: configuration.label, tip: configuration.tip, fullText: configuration.fullText }),
      this.inputBox
    ]);

  }

}

export default TextInputRow;